import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
// import Lowerb from "../components/lowerb";
import "./FAQ.css";

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: null, // Track active accordion item
    };
  }

  toggleAccordion = (index) => {
    this.setState((prevState) => ({
      activeIndex: prevState.activeIndex === index ? null : index,
    }));
  };

  render() {
    const faqData = [
      {
        question:
          "Considering past experiences as regards to fraudulent practices of somehow similar platforms, why should the wealth system be trusted?",
        answer:
          "The wealth system is entirely people centric. It is designed 100% to empower the society. The system has physical offices and is also designed, developed and managed by a reputable company registered with CAC in Nigeria.",
      },
      {
        question:
          "From the reward table as published, the figures are huge and over tempting, thus raises doubt on the system’s capacity to fulfill its financial obligations to users without going bankrupt in the nearest future. Should one not be skeptical?",
        answer:
          "To a non financial expert or a non mathematician, the figures might be huge. However, it’s just a fraction of what your task performance gave the system. The system is only giving out almost what it gets from the society, leaving little for system maintenance and upgrade, hence 40% referral bonus. It is a self sustaining system that can never go bankrupt because every considerations were made before it’s development by team of best brains.",
      },
      {
        question:
          "From experience, cash out has always been an issue after earning through task performance in most platforms. How is one sure that the same will not happen here?",
        answer:
          "The system reduced it’s minimal withdrawal threshold to N10,000 so as to allow users test the efficiency of the payout mechanism and decide on staying with the system or exiting. Anyways, the payout is guaranteed.",
      },
      {
        question: "Is the system hack free?",
        answer:
          "The system’s security is top notch, hence has a secured backend. The users have to make it more secured by creating a strong password upon signup and safeguard it too. Users should also activate the two factor authentication protocol to enable the system verify every payout request before approval.",
      },
      {
        question:
          "Is the loan not a scam designed to attract users into the platform since it does not require collateral?",
        answer:
          "It’s unfortunate that every good thing is seen wrongly. The system continues to reward users after they have finished performing their task to an unlimited amount. The loan is like an overdraft which shall have a negative effect on the users wallet balance and shall automatically be written off as more money is earned, hence does not require collateral.",
      },
      {
        question:
          "Why is it mandatory that whoever the system has rewarded above twenty million naira should establish a business that is capable of employing not less than three persons and upload evidence or face account suspension?",
        answer:
          "We are in a society where people like receiving but hate giving back. The clause is to encourage system beneficiaries appreciate the society from where their wealth came, though facilitated by the system. Moreover, viable business establishment helps solidifies wealth and makes sure no empowered user goes bankrupt after testing wealth.",
      },
    ];

    return (
      <div>
        <Header />

        {/* Hero Section */}
        <div className="faq-hero">
          <div className="faq-hero-content">
            <h1>Frequently Asked Questions</h1>
            <p>
              <Link to="/" className="breadcrumb-home">
                Home
              </Link>{" "}
              / <span className="breadcrumb-current">FAQs</span>
            </p>
          </div>
        </div>

        {/* FAQ Section */}

        <div className=" bg-dark">
          <div className="location pt-5 aboutInfo bg-dark  container-fluid">
            <div>
              <p style={{ paddingTop: "50px" }}></p>

              <div
                className="text-warning"
                style={{
                  fontSize: "30px",
                  fontWeight: "700",
                }}
              >
                Frequently Asked Questions
              </div>
              <label
                className=" text-light d-block"
                style={{ textAlign: "center", marginTop: "0px" }}
              >
                <p>
                  Find answers to the most common questions about our system.
                </p>
              </label>
            </div>

            <div className="pane pt-5 pb-5" style={{ textAlign: "justify" }}>
              <div className="row">
                {/* Left Side: FAQ Accordion */}
                <div className="col-lg-8">
                  <div
                    className="accordion border-2"
                    style={{ backgroundColor: "#ffffff0d" }}
                  >
                    {faqData.map((item, index) => (
                      <div
                        key={index}
                        className={`accordion-item p-4 ${
                          this.state.activeIndex === index ? "active" : ""
                        }`}
                        style={{
                          backgroundColor: "#ffffff0d",
                          borderTop: "none",
                          borderLeft: "none",
                          borderRight: "none",
                          borderBottom: "5px solid #ffffff0d",
                        }}
                      >
                        <button
                          className="accordion-header text-light"
                          onClick={() => this.toggleAccordion(index)}
                        >
                          <b style={{ fontSize: "20px" }}>{item.question}</b>
                          <span className="arrow">
                            {this.state.activeIndex === index ? "▲" : "▼"}
                          </span>
                        </button>
                        <div
                          className="accordion-content text-light"
                          style={{
                            maxHeight:
                              this.state.activeIndex === index
                                ? "800px"
                                : "0px",
                          }}
                        >
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right Side: FAQ Images */}
                <div className="col-lg-4">
                  <div className="faq-ri">
                    <div className="image--1"></div>
                    <div className="image--2"></div>
                    <div className="image--3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default FAQ;
